module.exports = __webpack_public_path__ + "img/image_not_available.7a863e3b.jpg";